import React, { useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, FormFeedback, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { useModalCrudState } from '../../../../_helper/hooks/useModalCrudState';

const FileTypeDataModal = ({ apiEndpoint, isOpen, toggle, mode, selectedFileType, refreshData }) => {
    const initialFileTypeData = {
        id: '',
        title: '',
    };

    const validationSchema = useMemo(() => ({
        title: {
            required: true,
            message: 'Dosya tipi başlığı zorunludur.',
            minLength: 2,
            minLengthMessage: 'Başlık en az 2 karakter olmalıdır.',
        },
    }), []);

    const {
        formData: fileTypeData,
        errors,
        handleCancel,
        handleInputChange,
        handleSubmit,
        isSubmitting,
    } = useModalCrudState({
        isOpen,
        mode,
        selectedItem: selectedFileType,
        initialData: initialFileTypeData,
        toggle,
        normalizeInput: true,
        validationSchema,
        submitConfig: {
            apiEndpoint,
            selectedItem: mode === 'modify' ? { id: selectedFileType?.id } : null,
            refreshData,
            componentName: 'Dosya Tipi',
            buildPayload: (data) => ({
                title: data.title,
                ...(mode === 'modify' && selectedFileType?.id && { id: selectedFileType.id }),
            }),
        },
    });

    const getModalTitle = () => {
        return mode === 'add' ? 'Dosya Tipi Ekle' : 'Dosya Tipi Düzenle';
    };

    const getButtonLabel = () => {
        return mode === 'add' ? 'Ekle' : 'Güncelle';
    };

    return (
        <Modal isOpen={isOpen} toggle={handleCancel} backdrop="static">
            <ModalHeader toggle={handleCancel}>{getModalTitle()}</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="title">Tür Adı <span className="text-danger">*</span></Label>
                        <Input
                            type="text"
                            id="title"
                            name="title"
                            value={fileTypeData.title || ''}
                            onChange={handleInputChange}
                            placeholder="Dosya Türü Adı"
                            invalid={!!errors.title}
                        />
                        <FormFeedback>{errors.title}</FormFeedback>
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="outline-success" className="rounded-pill" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? 'Kaydediliyor...' : getButtonLabel()}
                </Button>
                <Button color="outline-danger" onClick={handleCancel} className="ms-2 rounded-pill">
                    İptal
                </Button>
            </ModalFooter>
        </Modal>
    );
};

FileTypeDataModal.propTypes = {
    apiEndpoint: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    mode: PropTypes.oneOf(['add', 'modify']).isRequired,
    selectedFileType: PropTypes.object,
    refreshData: PropTypes.func.isRequired,
};

export default FileTypeDataModal;
